import React from "react";

const Card = (props) => {
    const css = `bg-white rounded-md p-5 shadow-md ${props.className}`;
    return <div className={css}>{props.children}</div>;
};

export default Card;
